import type { Branza, EstimateItem } from '../store/useProjectStore';

export type RecommendedRemovalWarning = {
  itemId: string;
  title: string;
  message: string;
  primaryActionLabel: string;
  secondaryActionLabel: string;
};

const TECHNOLOGY_CATEGORIES = new Set([
  'grunt',
  'hydro',
  'szlifowanie',
  'weather_protection',
  'akryl',
  'corner_beads',
]);

export function getRecommendedRemovalWarning(input: {
  item: EstimateItem;
  items: EstimateItem[];
  branza: Branza;
}): RecommendedRemovalWarning | null {
  const category = input.item.category ?? '';
  const hasPlaster = input.items.some((item) => item.category === 'gladz');
  const hasPainting = input.items.some((item) => item.category === 'malowanie');

  if (category === 'grunt' && (hasPlaster || hasPainting)) {
    return {
      itemId: input.item.id,
      title: 'Ostrzeżenie technologiczne',
      message:
        'Usuwasz gruntowanie przed gładzią lub malowaniem. Ryzykujesz odparzenia, nierówne chłonięcie i poprawki z własnej kieszeni.',
      primaryActionLabel: 'ZOSTAW ZALECANE',
      secondaryActionLabel: 'USUWAM NA WŁASNE RYZYKO',
    };
  }

  if (category === 'hydro' || (category === 'hydroizolacja' && input.branza === 'lazienka')) {
    return {
      itemId: input.item.id,
      title: 'Ostrzeżenie technologiczne',
      message:
        'Usuwasz hydroizolację w strefie mokrej. Jeśli pojawi się przeciek, koszt naprawy wróci do Ciebie.',
      primaryActionLabel: 'ZOSTAW ZALECANE',
      secondaryActionLabel: 'USUWAM NA WŁASNE RYZYKO',
    };
  }

  if (category === 'szlifowanie' && hasPlaster) {
    return {
      itemId: input.item.id,
      title: 'Ostrzeżenie technologiczne',
      message:
        'Usuwasz szlifowanie po gładzi. To wróci jako poprawka, bo pod malowanie wyjdą rysy i nierówności.',
      primaryActionLabel: 'ZOSTAW ZALECANE',
      secondaryActionLabel: 'USUWAM NA WŁASNE RYZYKO',
    };
  }

  if (category === 'weather_protection') {
    return {
      itemId: input.item.id,
      title: 'Ostrzeżenie technologiczne',
      message:
        'Usuwasz zabezpieczenie pogodowe. Przy deszczu lub silnym wietrze ryzykujesz przestój, poprawki i reklamację.',
      primaryActionLabel: 'ZOSTAW ZALECANE',
      secondaryActionLabel: 'USUWAM NA WŁASNE RYZYKO',
    };
  }

  if (TECHNOLOGY_CATEGORIES.has(category)) {
    return {
      itemId: input.item.id,
      title: 'Ostrzeżenie technologiczne',
      message:
        'Usuwasz zalecaną pozycję technologiczną. To może wrócić jako poprawka albo koszt z Twojej kieszeni.',
      primaryActionLabel: 'ZOSTAW ZALECANE',
      secondaryActionLabel: 'USUWAM NA WŁASNE RYZYKO',
    };
  }

  return null;
}
